import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { useDispatch } from 'react-redux';

import {
  changeStartdate,
  changeEndate,
} from '../../../../store/Cashbacks/CashbacksSlice';
import StorePresenter from '../../../../presenters/StorePresenter';
import {
  validationSchema,
  initialValues,
} from '../../../../forms/cashbacksFiltersForm';

import Form from './components/Form';

const CashbacksFilters = (props) => {
  const dispatch = useDispatch();
  const {
    searchParams,
    onSearchParamsChange,
    stores,
    storesLoadingState,
    onLoadData,
  } = props;
  const handleSubmit = (values, _actions) => {
    const newParams = {
      ...searchParams,
      q: { ...searchParams.q, ...values },
    };
    dispatch(changeStartdate(values.afterDate));
    dispatch(changeEndate(values.beforeDate));
    onSearchParamsChange(newParams);
    onLoadData(newParams);
  };

  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, actions) => handleSubmit(values, actions)}
      initialValues={initialValues(searchParams)}
      validationSchema={validationSchema}
    >
      {(props) => (
        <Form
          {...props}
          stores={stores}
          storesLoadingState={storesLoadingState}
        />
      )}
    </Formik>
  );
};

export default CashbacksFilters;

CashbacksFilters.propTypes = {
  searchParams: PropTypes.shape().isRequired,
  onSearchParamsChange: PropTypes.func.isRequired,
  onLoadData: PropTypes.func.isRequired,
  stores: PropTypes.arrayOf(StorePresenter.shape()),
  storesLoadingState: PropTypes.string.isRequired,
};

CashbacksFilters.defaultProps = {
  stores: null,
};
